export default __webpack_public_path__ + "static/media/eye-close.2975fe39.svg";